<div class="modal-container-custom">
  <div class="modal-content-custom">
    <div class="modal-header">
      <button type="button" id="close-confirm-modal" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">Confirm</h4>
    </div>
    <div class="dark-section py-6 px-4">
      <div class="enabled-text">{{ modalData.questionToAsk }}</div>
      <div *ngIf="modalData.promptText" class="font-italic warning-text text-center pt-5">
        {{ modalData.promptText }}
      </div>
    </div>

    <div class="modal-footer modal-footer-custom">
      <button *ngFor="let button of modalData.buttons; let i = index;" type="button" id="confirm-modal-btn-{{i}}"
        class="col-md-4 btn btn-style-right-1 text-left"
        [ngClass]="{'btn-outline-normal': button.role === 'cancel', 'btn-success': button.role === 'confirm', 'btn-outline-danger': button.role === 'reject' }"
        (click)="closeModalWith(button.role)">{{ button.name | titlecase }}
      </button>
    </div>
  </div>
</div>
